//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SidebarAnchors from "~/components/other/SidebarAnchors"
import List from '~/components/gallery/personal/List'
import { debounce } from '~/utils/utils'
import Mir from '@/components/gallery/personal/Mir'

export default {
  components: {
    Mir,
    SidebarAnchors,
    List
  },
  props: {
    tabletAnchors: {
      type: Boolean,
      default: false
    },
    collectionId: {
      type: [String, Number],
      default: ''
    },
    owner: {
      type: Boolean,
      default: false
    },
    haveMir: {
      type: Boolean,
      default: false
    },
    needReload: {
      type: Boolean,
      default: false
    },
    initialResponse: {
      type: Object,
      default: null
    }
  },
  data() {
    const data = this?.initialResponse?.data?.data || this.getMyCollectionChimera?.data?.data

    return{
      fontSizeForSafari: 0,
      loading: {
        patronat: true,
        opened: true,
        mir: true,
        holiday: true
      },
      image: null,
      needShortText: false,
      galleryName: data ? data[0].name : '',
      defaultTitle: this.$t('profile.galleryDefaultTitle'),
      edit: false
    }
  },
  computed: {
    checkLoaded() {
      const { patronat, opened, mir, holiday } = this.loading
      if (!this.myCollection.items) {
        return true
      }
      const { patronage, open, loyalty, holiday: holidayItems } = this.myCollection.items

      const currentPatronat = patronage ? !patronat : true
      const currentOpened = open ? !opened : true
      const currentMir = loyalty ? !mir : true
      const currentHoliday = holidayItems ? !holiday : true

      return currentPatronat && currentOpened && currentMir && currentHoliday
    },
    myCollection() {
      const data = this.getMyCollection?.data?.data

      return data ? data[0] : null
    },
    getMyCollection () {
      return this.initialResponse || this.getMyCollectionChimera
    }
  },
  watch: {
    needReload: function () {
      this.getMyCollection.reload()
    },
    galleryName: function () {
      if (this.galleryName) {
        this.fontSizeForSafari = this.galleryName.length % 2
      }
    }
  },
  mounted () {
    if (this.needShortText && (window.innerWidth > 1599 || window.innerWidth <= 1180)) {
      this.needShortText = false
    } else if (!this.needShortText && (window.innerWidth < 1600 && window.innerWidth > 1180)) {
      this.needShortText = true
    }
    window.addEventListener("resize", this.checkWindowWidth);
  },
  beforeDestroy () {
    window.removeEventListener("resize", this.checkWindowWidth);
  },
  methods:{
    checkWindowWidth: debounce(function() {
      if (this.needShortText && (window.innerWidth > 1599 || window.innerWidth <= 1180)) {
        this.needShortText = false
      } else if (!this.needShortText && (window.innerWidth < 1600 && window.innerWidth > 1180)) {
        this.needShortText = true
      }
    }, 50),
    toggleEdit(){
      if (this.edit) {
        // this.galleryName = this.myCollection.name
        this.changeCollectionName()
      }
      this.edit = !this.edit;
      setTimeout(()=>{
        this.$refs.titleTextarea.focus()
      },100)
    },
    // mediaHandler (e) {
    //   this.tabletAnchors = e.matches
    // },
    preventEnter(e){
      if(e.keyCode === 13){
        e.preventDefault()
        this.edit = false;
        setTimeout(()=>{
          this.$refs.titleTextarea.blur()
        },100)
      }
    },
    changeCollectionName() {
      if (this.galleryName !== this.getMyCollection.data.data[0].name) {
        this.$axios({
          method: 'post',
          url: '/api/v1/collection/update',
          data: `id=${this.collectionId}&name=${this.galleryName}&lang=${this.$i18n.locale || 'ru'}`
        })
      }
    },
    share(name) {
      let url
      const title = this.$i18n.locale === 'en' ? 'My Tretyakov' : 'Моя Третьяковка'
      const description = this.myCollection?.name || this.$i18n.locale === 'en' ? 'My Collection' : 'Моя коллекция'
      const image = this.myCollection.picture || ''
      const shortUrl = `${window.location.origin || 'https://my.tretyakov.ru'}/app/collection/${this.collectionId}`

      switch(name) {
        case 'vk':
          url = `https://vk.com/share.php?url=${shortUrl}&title=${title}&description=${description}`
          if (image) {
            url += `&image=${image}`
          }
          break
        case 'ok':
          url = `https://connect.ok.ru/offer?url=${shortUrl}&title=${title}&description=${description}`
          if (image) {
            url += `&imageUrl=${image}`
          }
          break
        default:
          return
      }
      this.popup(url);
    },
    popup (url) {
      const social_window = window.open(url, "share_window", `height=500,width=800,top=${window.innerHeight / 2 - 250},left=${window.innerWidth / 2 - 400}`);
      social_window.focus();
    }
  },
  head() {
    const seo = this.myCollection?.items || {}
    let title = seo.browserTitle
    if (title) {
      title = title.replace(/&quot;/g, '"').replace(/&lsquo;/g, '‘').replace(/&laquo;/g, '«').replace(/&raquo;/g, '»')
    }
    return {
      title: title
    }
  },
  chimera: {
    getMyCollectionChimera () {
      return {
        url: '/api/v1/collection/get/',
        key: `get-collection-${this.collectionId}`,
        auto: !this.initialResponse,
        prefetch: false,
        params: {
          userId: this.collectionId,
          lang: this.$i18n.locale || 'ru'
        },
        on: {
          success (res) {
            this.galleryName = res?.data?.data ? res?.data?.data[0].name : ''
            // setTimeout(() => this.$emit('loaded'), 1000)
            // this.$emit('collection', this.myCollection)
          }
        }
      }
    }
  }
}
